import React from 'react';
import { useAppSelector } from '../../hooks/redux';

const BadgesDisplay: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  const badges = user?.badges || [];

  if (badges.length === 0) {
    return (
      <div className="bg-[var(--color-default-background)] p-6 rounded-lg shadow-sm">
        <h3 className="text-lg font-semibold mb-4 text-[var(--color-default-font)]">Badges</h3>
        <p className="text-[var(--color-subtext-color)]">No badges earned yet</p>
      </div>
    );
  }

  return (
    <div className="bg-[var(--color-default-background)] p-6 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold mb-4 text-[var(--color-default-font)]">Badges</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {badges.map((badge: any) => (
          <div
            key={badge.badgeId}
            className="flex flex-col items-center p-4 border border-[var(--color-neutral-border)] rounded-lg hover:shadow-md transition-shadow"
            title={badge.description}
          >
            {badge.icon ? (
              <img src={badge.icon} alt={badge.name} className="w-12 h-12 mb-2" />
            ) : (
              <div className="w-12 h-12 bg-[var(--color-brand-100)] rounded-full flex items-center justify-center mb-2">
                <span className="text-2xl">🏆</span>
              </div>
            )}
            <p className="text-sm font-medium text-center text-[var(--color-default-font)]">{badge.name}</p>
            <p className="text-xs text-[var(--color-subtext-color)] mt-1">
              {new Date(badge.awardedAt).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BadgesDisplay;

